import { animate, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, ElementRef, HostListener, ViewChild, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { IPrincipalesCambiosReforma, IConfiguracionesTexto, IPrincipalesCambiosMap } from '@interfaces/reforma-configuraciones-texto.interface';
import { FirestoreService } from '@services/firestore/firestore.service';

const ORDEN_CAMBIOS: (keyof IPrincipalesCambiosMap)[] = [
  'fondos-generacionales',
  'aumento-cotizacion',
  'licitacion-stock',
  'nuevo-seguro-social'
];

@Component({
    selector: 'app-principales-cambios',
    templateUrl: './principales-cambios.component.html',
    styleUrl: './principales-cambios.component.scss',
    animations: [
      trigger('fadeInOut', [
        transition(':enter', [
          style({ opacity: 0, transform: 'translateY(24px)' }),
          animate('300ms cubic-bezier(0.23, 1, 0.32, 1)', style({ opacity: 1, transform: 'translateY(0)' }))
        ]),
        transition(':leave', [
          style({ position: 'absolute', width: '100%', opacity: 1 }),
          animate('200ms', style({ opacity: 0 }))
        ])
      ])
    ],
    standalone: false
})
export class PrincipalesCambiosComponent implements AfterViewInit {

  @ViewChild('changesTrack') changesTrack?: ElementRef<HTMLDivElement>;

  private readonly firestoreService = inject(FirestoreService);

  selectedCambio = 'fondos-generacionales';
  canScrollLeft = false;
  canScrollRight = false;

  principalesCambios$: Observable<(IPrincipalesCambiosReforma & { key: string })[]> =
    this.firestoreService.getDoc<IConfiguracionesTexto>('reforma-pensiones', 'configuraciones-texto').pipe(
      map(config => {
        const cambios = config?.['Conoce-mas-sobre-la-reforma']?.['principales-cambios'];
        if (!cambios) {
          console.warn('No se encontró el campo "principales-cambios"');
          return [];
        }
        return ORDEN_CAMBIOS.map(key => ({ key, ...cambios[key] }));
      })
    );

  selectCambio(key: string): void {
    this.selectedCambio = key;
  }

  ngAfterViewInit(): void {
    this.updateScrollState();
    requestAnimationFrame(() => this.updateScrollState());
  }

  updateScrollState(): void {
    const track = this.changesTrack?.nativeElement;
    if (!track) return;
    this.canScrollLeft = track.scrollLeft > 1;
    this.canScrollRight = track.scrollLeft + track.clientWidth < track.scrollWidth - 1;
  }

  scrollChanges(direction: 'left' | 'right'): void {
    const track = this.changesTrack?.nativeElement;
    if (!track) return;
    track.scrollBy({
      left: direction === 'left' ? -track.clientWidth : track.clientWidth,
      behavior: 'smooth'
    });
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.updateScrollState();
  }
}